/*
 * NANOAGRO — Origen del lead (casos de estudio → formulario de ensayo)
 *
 * Para saber cuántas solicitudes de ensayo salen de cada caso de estudio.
 *
 * 1. En las páginas de un caso (sección caso-estudio.liquid): al hacer clic en el
 *    botón que lleva al formulario de ensayo manda a GA4 el evento `cta_caso`
 *    ({ caso: 'maiz' | 'tomate', pagina }) y publica `nano_cta_caso` para el
 *    píxel personalizado de Meta (que lo convierte en "CTACaso"). Los enlaces ya
 *    traen ?origen=caso-maiz&utm_…; si alguno no lo trae (p. ej. una página nueva
 *    del caso), se le agrega aquí según la URL.
 *
 * 2. En el formulario de ensayo (sección trial-form.liquid): lee ?origen= y los
 *    utm_*, los recuerda en sessionStorage (el envío recarga la página y se pierde
 *    la URL), añade el origen a contact[tags] y lo escribe en el campo oculto
 *    "Origen del lead", que llega en el correo de Shopify.
 *
 * 3. Envío correcto del formulario: manda a GA4 `generate_lead` una sola vez.
 *    El Lead de Meta NO se manda aquí: ya lo hace nanoagro-expedientes-cliente.js
 *    (evento `nano_formulario_enviado`, deduplicado con el del servidor).
 *
 * Reglas: si este archivo falla o no carga, el formulario y los botones funcionan
 * igual; ningún evento de medición bloquea la navegación ni el envío.
 * Lo cargan caso-estudio.liquid y trial-form.liquid, con defer.
 */
(function () {
  'use strict';
  if (window.__naOrigenLead) return; /* el editor puede cargar el archivo dos veces */
  window.__naOrigenLead = true;

  var FORM = '/pages/solicita-un-ensayo-gratuito-con-nanoagro';
  var LLAVE = 'na_origen_lead';        /* origen recordado en la sesión */
  var LLAVE_GA4 = 'na_ga4_lead_hecho'; /* evita mandar generate_lead dos veces */
  var VIGENCIA = 2 * 60 * 60 * 1000;   /* 2 h: después ya no es la misma visita */
  var RE_VALOR = /^[a-z0-9][a-z0-9_-]{0,59}$/;

  function limpio(v) {
    v = String(v || '').toLowerCase().trim();
    return RE_VALOR.test(v) ? v : '';
  }
  function ga4(nombre, datos) {
    try { if (typeof window.gtag === 'function') window.gtag('event', nombre, datos); }
    catch (e) { /* la medición nunca rompe la página */ }
  }
  function publicar(nombre, datos) {
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(nombre, datos);
    } catch (e) { /* idem */ }
  }
  function leer(llave) {
    try { return JSON.parse(sessionStorage.getItem(llave) || 'null'); } catch (e) { return null; }
  }
  function guardar(llave, valor) {
    try { sessionStorage.setItem(llave, JSON.stringify(valor)); } catch (e) { /* modo privado */ }
  }
  /* /en/pages/x → /pages/x */
  function sinIdioma(ruta) { return ruta.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/pages\/)/i, ''); }

  /* ── 1. Clic en el botón de un caso ──────────────────────────────────────── */
  document.addEventListener('click', function (ev) {
    var a = ev.target && ev.target.closest ? ev.target.closest('a[href]') : null;
    if (!a) return;
    var url;
    try { url = new URL(a.href, location.href); } catch (e) { return; }
    if (url.host !== location.host || sinIdioma(url.pathname) !== FORM) return;

    var origen = limpio(url.searchParams.get('origen'));
    if (!origen) {
      if (!a.closest('.cde')) return;          /* fuera de un caso: no es un CTA de caso */
      var m = location.pathname.match(/maiz|tomate/);
      var c = m ? m[0] : 'otro';
      origen = 'caso-' + c;
      url.searchParams.set('origen', origen);
      url.searchParams.set('utm_source', 'nano-agro');
      url.searchParams.set('utm_medium', 'caso');
      url.searchParams.set('utm_campaign', c);
      a.href = url.toString();                 /* se cambia antes de que el navegador navegue */
    }
    if (origen.indexOf('caso-') !== 0) return;

    var datos = { caso: origen.slice(5), pagina: sinIdioma(location.pathname) };
    ga4('cta_caso', datos);
    publicar('nano_cta_caso', datos);
  }, true);

  /* ── 2 y 3. Formulario de ensayo ─────────────────────────────────────────── */
  var form = document.querySelector('.trial-form-section form');
  if (!form) return;

  var q = new URLSearchParams(location.search);
  var dato = null;
  var origenUrl = limpio(q.get('origen'));
  var utmUrl = limpio(q.get('utm_source'));
  if (origenUrl || utmUrl) {
    dato = {
      origen: origenUrl,
      source: utmUrl,
      medium: limpio(q.get('utm_medium')),
      campaign: limpio(q.get('utm_campaign')),
      content: limpio(q.get('utm_content')),
      t: Date.now()
    };
    guardar(LLAVE, dato);
  } else {
    dato = leer(LLAVE);
    if (!dato || Date.now() - (dato.t || 0) > VIGENCIA) dato = null;
  }

  /* Texto que llega en el correo, p. ej.
     "caso-maiz | nano-agro / caso / maiz / suelo" — o "directo" si no hay origen. */
  var texto = 'directo';
  if (dato) {
    var utm = [dato.source, dato.medium, dato.campaign, dato.content].filter(Boolean).join(' / ');
    texto = [dato.origen, utm].filter(Boolean).join(' | ') || 'directo';
  }

  var campo = form.querySelector('input[name="contact[Origen del lead]"]');
  if (!campo) {
    campo = document.createElement('input');
    campo.type = 'hidden';
    campo.name = 'contact[Origen del lead]';
    form.appendChild(campo);
  }
  campo.value = texto;

  if (dato && dato.origen) {
    var tags = form.querySelector('input[name="contact[tags]"]');
    if (tags && (',' + tags.value.replace(/\s/g, '') + ',').indexOf(',' + dato.origen + ',') === -1) {
      tags.value = tags.value ? tags.value + ', ' + dato.origen : dato.origen;
    }
  }

  /* Envío correcto: Shopify vuelve a la página con ?contact_posted=true y la
     sección pinta .form-success-message (luego redirige a /pages/gracias-…). */
  var exito = form.querySelector('.form-success-message') || /[?&]contact_posted=true/.test(location.search);
  if (exito) {
    var previo = leer(LLAVE_GA4);
    if (!previo || Date.now() - (previo.t || 0) > 15 * 60 * 1000) {
      guardar(LLAVE_GA4, { t: Date.now() });
      ga4('generate_lead', {
        formulario: 'ensayo',
        origen: (dato && dato.origen) || 'directo',
        caso: dato && dato.origen && dato.origen.indexOf('caso-') === 0 ? dato.origen.slice(5) : '',
        utm_campaign: (dato && dato.campaign) || ''
      });
    }
    /* el origen ya se usó: no se le atribuye a un envío posterior */
    try { sessionStorage.removeItem(LLAVE); } catch (e) { /* nada */ }
  }
})();
